import React from "react";

const ContactIcon = ({ ...rest }) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M29.3327 22.6667V17.3333C29.3327 9.96954 23.3631 4 15.9993 4C8.63555 4 2.66602 9.96954 2.66602 17.3333V22.6667M9.99935 28C8.1584 28 6.66602 26.5076 6.66602 24.6667V20.6667C6.66602 18.8257 8.1584 17.3333 9.99935 17.3333C11.8403 17.3333 13.3327 18.8257 13.3327 20.6667V24.6667C13.3327 26.5076 11.8403 28 9.99935 28ZM21.9993 28C20.1584 28 18.666 26.5076 18.666 24.6667V20.6667C18.666 18.8257 20.1584 17.3333 21.9993 17.3333C23.8403 17.3333 25.3327 18.8257 25.3327 20.6667V24.6667C25.3327 26.5076 23.8403 28 21.9993 28Z" 
                stroke="#2A2E44" 
                strokeWidth="2.67" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
        </svg>
    );
};

export default ContactIcon;
